import { NgxLoggerLevel } from 'ngx-logger';
import { APP_VERSION } from '../app-version';


export const environment = {
  production: true,
  version: APP_VERSION.replace('0.0.', ''),
  apiUrl: 'https://portal.salfeld.net/api/',
  apiFiles : 'https://portal.salfeld.net/files/',
  imgScreenshotSetupDE: 'https://portal.salfeld.net/images/screenshot-prepare-de.jpg',
  imgScreenshotSetupEN: 'https://portal.salfeld.net/images/screenshot-prepare-en.jpg',
  logLevel: NgxLoggerLevel.ERROR,
  ga : 'UA-2412316-5'
};

